import React from "react";
import "./style.css";

// Under developing
export const PreLoader = ({ color = "white", size = "lg" }) => {
  return (
    <div className={`sk-chase loader-color-${color} loader-size-${size}`}>
      <div className="sk-chase-dot"></div>
      <div className="sk-chase-dot"></div>
      <div className="sk-chase-dot"></div>
      <div className="sk-chase-dot"></div>
      <div className="sk-chase-dot"></div>
      <div className="sk-chase-dot"></div>
    </div>
  );
};

PreLoader.propTypes = {};
